import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import Banner from "../components/banner"
import bannerImg from "../images/management/enterprise/enterprise.png"
import mobbannerImg from "../images/management/enterprise/mobEnterprise.png"
import content1 from "../images/management/enterprise/ent-content.png"
import { Button, useTheme, makeStyles } from "@material-ui/core"
import CustomProducts from "../components/cards/custom-products/index"
import product1 from "../images/emp.png"
import NewProducts from "../components/cards/newproducts/index"
import SubPageBanner from "../components/subpagebanner/SubPageBanner"
import { navigate } from "gatsby"

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3rem 6rem',
  },
  img: {
    height: '400px',
    width: '1200px',
  },
}))

const Enterprise = ({ data, location: { pathname } }) => {

  const classes = useStyles()
  const theme = useTheme()

  const sectionData = {
    title: "Enterprise Search",
    content: `Wersel Workdesk provides a search platform similar to\n search engines that facilitates effective keyword searches\n to the organization and people data.`,
    buttonText: "Book Demo",
    buttonClick: () => navigate("/contact"),
    products: [
      {
        featureDescription: "Enterprise Search is a safe, secure, and configurable search platform that alleviates the view of highly informative content from various data sources.",
        featureDescription2: "This platform ensures secured and organized search results.",
        featureDescription3: "Wersel Workdesk enables opportunities to search, view, analyze, configure, save and collaborate the search results with specified access permissions that support effective understanding and decision-making within the organization.",
        featureImage: content1,
        imagePosition: "right",
        // url: "/products/discoverx/",
      },
    ],
  }
   const { products, title, content, buttonText, buttonClick } = sectionData

  return (
    <Layout withBrand slidePosition={0}>
      <SEO
        description="Deliver a phenomenal experience to your targeted shoppers and ensure that your brand maintains its credibility in the market with our brand analytics platform"
        keywords="brand analytics, brand analytics platform, brand analytics software, wersel, wersel brand analytics, wersel data hub"
        title="Wersel - AI Enabled People Analytics & Insights Software"
        url="www.wersel.io/"
      />
      <div style={{ paddingTop: '3px' }}>
        <SubPageBanner webbannerimg={bannerImg}  mobbannerimg={mobbannerImg} bannerHeading={title} bannerContent={content} buttonClick={buttonClick} buttonText={buttonText} />
      </div>
    {/* <div className={classes.content}>
        <div>
          <p>Enterprise Search is a safe, secure, and configurable search platform that alleviates the view of highly informative content from various data sources.</p>
          <p>This platform ensures secured and organized search results.</p>
          <p>Wersel Workdesk enables opportunities to search, view, analyze, configure, save and collaborate the search results with specified access permissions that support effective understanding and decision-making within the organization.</p>
        </div>
        <div className={classes.img}>
          <img src={content1} alt="article" />
        </div>
    </div> */}
    {/* <CustomProducts features={products} homePage={true} /> */}
    <NewProducts features={products} homePage={true} type='enterprise' />
    </Layout>
  )
}


export default Enterprise
